import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from '../truncate/truncate.pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [TruncatePipe],
  exports: [TruncatePipe],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class PipesCommonModule { 
//   static forRoot() {
//     return {
//         ngModule: PipesCommonModule,
//         providers: [],
//     };
//  }
}
